type StatusErrorResponse = {
  data: unknown;
  ok: boolean;
  headers: Headers;
  status: number;
};

type StatusError = Error & {
  status: number;
  response: StatusErrorResponse;
};

// ok is optional in the parameter type for compatibility with ComposedReturnType,
// which omits `ok` from its type definition despite always having it at runtime.
const statusErrorInterceptor = (
  response: Omit<StatusErrorResponse, 'ok'> & { ok?: boolean },
): typeof response => {
  if (!response.ok) {
    const error = new Error(`HTTP Error ${response.status}`) as StatusError;
    error.status = response.status;
    error.response = response as StatusErrorResponse;
    throw error;
  }

  return response;
};

export type { StatusError, StatusErrorResponse };
export default statusErrorInterceptor;
